import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMoneyBill,
    faCreditCard,
    faFileContract,
    faCodeBranch,
} from "@fortawesome/free-solid-svg-icons";

const PAYMENT_METHOD_MAP = {
    CASH:           { icon: faMoneyBill,    label: 'Espèces', color: '#16a34a', bg: '#dcfce7' },
    CARD:           { icon: faCreditCard,   label: 'Carte',   color: '#1e40af', bg: '#eff2ff' },
    CHECKS_PAYMENT: { icon: faFileContract, label: 'Chèque',  color: '#7c3aed', bg: '#f5f3ff' },
    SPLIT_PAYMENT:  { icon: faCodeBranch,   label: 'À crédit', color: '#92400e', bg: '#fffbeb' },
};

const PaymentMethodBadge = ({ method }) => {
    const m = PAYMENT_METHOD_MAP[method];
    if (!m) return null;
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 5,
            background: m.bg, color: m.color,
            padding: '3px 9px', borderRadius: 999,
            fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
        }}>
            <FontAwesomeIcon icon={m.icon} style={{ fontSize: 10 }} />
            {m.label}
        </span>
    );
};

export default PaymentMethodBadge;
